import {mcpRegistryAppBuilder} from '../config/app-builder'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import type {McpDetailsResponse} from '../types'

export const mcpDetailsRoute = mcpRegistryAppBuilder.createQueryRouteConfig('mcpDetailsRoute', {
  path: '/mcp/*',
  queries: [
    mainQuery<McpDetailsResponse>({
      queryDeps: ({pathname, params}) => {
        const name = (params as Record<'*', string>)['*']
        return {pathname, name}
      },
    }),
  ],
})
